import { Container } from "@mui/material";
import Announce from "../components/Announce";

function AnnPage(){
    return(
        <Container>
            <Announce/>
        </Container>
    )
}

export default AnnPage